// extracted by mini-css-extract-plugin
export default {"modalContainer":"organizationModal_modalContainer__zPeKN"};